<template>
  <section id="search" class="">
    <div class="search-type">
      <b-radio
        v-if="$conf.search.length > 1"
        v-for="(item, i) in $conf.search"
        v-model="index"
        name="searchIndex"
        size="is-small"
        type="is-info"
        :style="{visibility: 'hidden'}"
        :key="i"
        :native-value="i">
        {{ $t(item.name) }}
      </b-radio>
    </div>
    <b-field :label="$t('search')">
      <b-input
        type="search"
        custom-class="has-background-grey has-text-light"
        icon="magnify"
        :icon-right="query.length ? 'close' : ''"
        icon-right-clickable
        @icon-right-click="clearSearch"
        v-model="query"
        @keyup.enter.native="search"
        :placeholder="$t($conf.search[index].name + '.placeholder')">
      </b-input>
    </b-field>
  </section>
</template>

<script>

import log from 'util/log'

export default {
  data () {
    return {
      query: ''
    }
  },
  computed: {
    index: {
      get () {
        return this.$store.getters['searchIndex'] || 0
      },
      set (idx) {
        this.$store.commit('searchIndex', idx)
      }
    }
  },
  methods: {
    search () {
      // hack to get over search result component updated called twice
      this.$store.dispatch('clearSearch')
      this.$store.dispatch('search', {
        index: this.index,
        query: this.query
      })
        .then((results) => {
          if (results && results.length) {
            this.$map.fitTo({
              bbox: this.$map.bbox(results.map(result => result.geometry)),
              srid: this.$conf.api.srid || 'EPSG:4326'
            })
          }
        })
        .catch(err => {
          this.$conf.debug && console.error(err)
          log('danger', this.$t(this.$conf.search[this.index].error))
        })
    },
    clearSearch () {
      this.$store.dispatch('clearSearch')
      this.query = ''
    }
  }
}

</script>

<style lang="stylus">

#search
  margin: 6px
  .search-type
    float: right
  label
    color: white
  .input
    &::placeholder
      color: white
      opacity: 1
    &:-ms-input-placeholder
      color: white
    &::-ms-input-placeholder
      color: white
    &:focus
      border: 1px solid white
      box-shadow: none
  .control.has-icons-left .input:focus ~ .icon
    color: white
  input[type="search"]::-webkit-search-decoration,
  input[type="search"]::-webkit-search-cancel-button,
  input[type="search"]::-webkit-search-results-button,
  input[type="search"]::-webkit-search-results-decoration
    -webkit-appearance:none
  input[type=search]::-ms-clear,
  input[type=search]::-ms-reveal
    display: none
    width: 0
    height: 0

</style>
